import { Builder, withChildren } from '@builder.io/react';

import TabCTA from './index';

const TabCTAWithBuilderChildren = withChildren(TabCTA)

Builder.registerComponent(TabCTAWithBuilderChildren, {
  name: 'TabCTA',
  inputs: [
    {
      name: 'href',
      type: 'string',
      defaultValue: null
    },
    {
      name: 'text',
      type: 'string',
      defaultValue: 'Click me!'
    },
    {
      name: 'icon',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['svg', 'jpeg', 'png']
        },
        { name: 'width', type: 'number' },
        { name: 'height', type: 'number' },
        { name: 'alt', type: 'string' }
      ]
    }
  ]
});
